var map = {
	"./es": 195,
	"./fr": 196
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;


//////////////////
// WEBPACK FOOTER
// /Users/v625154/work/perspective/node_modules/moment/locale (en|es|fr)$
// module id = 194
// module chunks = 0